// extracted by mini-css-extract-plugin
module.exports = {"minimumEnvText":"style_minimumEnvText__3tXXbGHU9jSBGhA9ABn0rE","minCompleteLabel":"style_minCompleteLabel__1OGQsnrMi7FYDz8Tn4EOrw"};